import React from "react";
import {
  CONSENT_SUFFIX,
  ELIGIBILITY_RESULT_CONTENT,
} from "../../data/eligibilityResultContent";
import type { EligibilityResultStatus } from "../../utils/eligibilityResult";

/**
 * The eligibility agreement, as one checkbox (client worklist #79).
 *
 * It used to be one required checkbox per acknowledgement — five or six of
 * them. The client-approved wording is unchanged and still shown in full, as
 * a list; the applicant now agrees to it once, with the consent sentence that
 * already sat beneath the list.
 *
 * Shared by the result page and the payment page, so an applicant who reaches
 * payment from the dashboard sees exactly the agreement the result page would
 * have shown them.
 */
type Props = {
  tier: EligibilityResultStatus;
  checked: boolean;
  onChange: (checked: boolean) => void;
  heading?: string;
  disabled?: boolean;
};

const EligibilityAgreement: React.FC<Props> = ({
  tier,
  checked,
  onChange,
  heading = "Before You Continue",
  disabled = false,
}) => {
  const { acknowledgements } = ELIGIBILITY_RESULT_CONTENT[tier];
  const checkboxId = `eligibility-agreement-${tier}`;

  return (
    <div
      style={{
        backgroundColor: "#F9FAFB",
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        padding: "20px 22px",
        marginTop: "28px",
      }}
    >
      <h6
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          color: "#1B365D",
          marginBottom: "12px",
        }}
      >
        {heading}
      </h6>

      <ul
        style={{
          listStyle: "disc",
          paddingLeft: "20px",
          margin: "0 0 16px",
          fontSize: "13.5px",
          lineHeight: 1.5,
          color: "#1F2933",
        }}
      >
        {acknowledgements.map((text) => (
          <li key={text} style={{ marginBottom: "8px" }}>
            {text}
          </li>
        ))}
      </ul>

      <label
        htmlFor={checkboxId}
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          fontSize: "13.5px",
          lineHeight: 1.5,
          color: "#1F2933",
          fontWeight: 600,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        <input
          id={checkboxId}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          style={{ marginTop: "3px", flex: "0 0 auto" }}
        />
        <span>{CONSENT_SUFFIX}</span>
      </label>
    </div>
  );
};

export default EligibilityAgreement;
